import { useTranslation } from 'react-i18next';
import { StandardModal } from '@/components/molecules/common/Modal';
import { Stack, Typography } from '@mui/material';
import { useDeleteVerifiedPhone } from '@/hooks/client';

interface RemoveVerifiedPhoneProps {
  clientId: string;
  onClose: () => void;
  refetchClient: () => void;
}

const RemoveVerifiedPhoneModal = ({ clientId, onClose, refetchClient }: RemoveVerifiedPhoneProps) => {
  const { t } = useTranslation();

  const { mutate: deletePhoneNumber, isLoading, errorMessage } = useDeleteVerifiedPhone();

  const handleSubmit = () =>
    deletePhoneNumber(
      { clientId },
      {
        onSuccess: () => {
          refetchClient();
          onClose();
        },
      },
    );

  return (
    <StandardModal
      title={t('client.basic_info.remove_verified_phone.title')}
      onClose={onClose}
      onSubmit={handleSubmit}
      submitLabel={t('common.submit')}
      submittable={!isLoading}
      body={
        <Stack sx={{ gap: 1 }}>
          <Typography>{t('client.basic_info.remove_verified_phone.description')}</Typography>

          {!!errorMessage && (
            <Typography
              color="error"
              variant="body2"
            >
              {errorMessage}
            </Typography>
          )}
        </Stack>
      }
      containerStyle={{ maxWidth: 500 }}
      modalName="remove-verified-phone-modal"
    />
  );
};

export default RemoveVerifiedPhoneModal;
